import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/camera-permission.png'
import _imports_1 from '@/assets/phone_icon.svg'
import _imports_2 from '@/assets/phone_icon_oanda.svg'
import _imports_3 from '@/assets/upload-instructions/camera.svg'
import _imports_4 from '@/assets/upload-instructions/howToTakeGoodPicture.svg'
import _imports_5 from '@/assets/upload-instructions/switchToManual.svg'
import _imports_6 from '@/assets/upload-instructions/securityOfYourData.svg'
import _imports_7 from '@/assets/upload-instructions/skipUpload.svg'


const _withScopeId = n => (_pushScopeId("data-v-77625712"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid": "step-uploadDocument-mobile",
  class: "container upload--mobile"
}
const _hoisted_2 = {
  key: 0,
  class: "camera-popup"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "recommended_header"
}
const _hoisted_9 = { class: "recommended_header_lines" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_11 = { class: "recommended_header_center" }
const _hoisted_12 = {
  key: 0,
  src: _imports_1,
  alt: "phone icon"
}
const _hoisted_13 = {
  key: 1,
  src: _imports_2,
  alt: "phone icon"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_15 = {
  key: 1,
  class: "container__subheader t-bold t-center"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 3,
  class: "container__subheader t-bold t-center"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "?", -1))
const _hoisted_19 = {
  key: 4,
  class: "front-side-thank-you"
}
const _hoisted_20 = {
  key: 1,
  class: "recommended-path-header"
}
const _hoisted_21 = {
  key: 0,
  src: _imports_1,
  alt: "phone icon"
}
const _hoisted_22 = {
  key: 1,
  src: _imports_2,
  alt: "phone icon"
}
const _hoisted_23 = { key: 2 }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  key: 2,
  class: "container__subheader t-bold t-center"
}
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = {
  key: 4,
  class: "container__subheader t-bold t-center"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "?", -1))
const _hoisted_29 = { key: 6 }
const _hoisted_30 = { class: "secure-connection" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  key: 1,
  class: "photo-upload-help"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "photo-upload-help__background" }, null, -1))
const _hoisted_34 = { class: "photo-upload-help__content" }
const _hoisted_35 = { class: "photo-upload-help__header" }
const _hoisted_36 = { class: "photo-upload-help__list" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_42 = {
  key: 2,
  class: "front-side-thank-you"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HowToTakePicture = _resolveComponent("HowToTakePicture")!
  const _component_UploadInstructions = _resolveComponent("UploadInstructions")!
  const _component_SecurityPopup = _resolveComponent("SecurityPopup")!
  const _component_NavigationButton = _resolveComponent("NavigationButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isShowWelcomeMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.browserAccess`)), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.allowCamera`)), 1),
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleInitCamera && _ctx.handleInitCamera(...args)))
                }, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.next`)), 1))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["client-zone-loader", { oanda: _ctx.UtilityHelper.isOandaPath() }])
                }, null, 2))
          ])
        ]))
      : (!_ctx.isShowWelcomeMessage && _ctx.noPermissions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (!_ctx.isBadUpload)
                ? (_openBlock(), _createElementBlock("h1", {
                    key: 0,
                    class: "container__standard-header",
                    innerHTML: _ctx.$t(`${_ctx.translationKey}.UploadPhotoIdentityDocument`)
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(!_ctx.isMobile && 'recommended_path_container')
              }, [
                (!_ctx.isMobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("div", _hoisted_11, [
                          (!_ctx.UtilityHelper.isOandaPath())
                            ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                            : _createCommentVNode("", true),
                          (_ctx.UtilityHelper.isOandaPath())
                            ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.alternatePathLabel`)), 1)
                        ]),
                        _hoisted_14
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isBadUpload)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.IDisClear`)), 1))
                  : _createCommentVNode("", true),
                (_ctx.isBadUpload)
                  ? (_openBlock(), _createElementBlock("h1", {
                      key: 2,
                      class: "container__standard-header",
                      innerHTML: _ctx.$t(`${_ctx.translationKey}.uploadAgain`)
                    }, null, 8, _hoisted_16))
                  : _createCommentVNode("", true),
                (_ctx.isBadUpload)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.uploadAgainInstructions`)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "photo-examples",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleShowPopup && _ctx.handleShowPopup(...args)))
                }, [
                  _hoisted_18,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.translationKey}.GoodAndBadPhotoExamples`)), 1)
                ]),
                (_ctx.isBack)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.FrontSideThankYou`)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass({ 'manual-upload': _ctx.isPhotoUpload })
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["gbg-camera-container desktop-container", {
                                'show-help': _ctx.showHelp,
                                'show-camera': _ctx.isShowCamera,
                            }])
                  }, [
                    (_ctx.showPopup)
                      ? (_openBlock(), _createBlock(_component_HowToTakePicture, {
                          key: 0,
                          "is-popup": true
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      id: "gbgContainer",
                      ref: "gbgContainer",
                      class: _normalizeClass(["gbgContainer", {
                                    'oanda-loader': _ctx.UtilityHelper.isOandaPath(),
                                    'show-loader': _ctx.showLoader,
                                    'photo-upload': _ctx.isPhotoUpload,
                                }])
                    }, null, 2)
                  ], 2)
                ], 2)
              ], 2),
              (!_ctx.isMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (!_ctx.UtilityHelper.isOandaPath())
                      ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                      : _createCommentVNode("", true),
                    (_ctx.UtilityHelper.isOandaPath())
                      ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.recommendedMobilePathLabel`)), 1)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isMobile)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "navigation-link up-mobile",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleBackToMobileUpload && _ctx.handleBackToMobileUpload(...args)))
                  }, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.uploadFromMobileButton`)) + " » ", 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", {
                class: _normalizeClass(['t-center', { 'is-mobile': _ctx.isMobile }])
              }, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.skipStepReminder`)), 3),
              _createElementVNode("button", {
                type: "button",
                class: "navigation-link link up-later",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleUploadLater && _ctx.handleUploadLater(...args)))
              }, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.uploadLaterButton`)) + " » ", 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
            (_ctx.showInstructions)
              ? (_openBlock(), _createBlock(_component_UploadInstructions, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.isPhotoUpload && !_ctx.isBadUpload)
              ? (_openBlock(), _createElementBlock("h1", {
                  key: 1,
                  class: "container__standard-header",
                  innerHTML: _ctx.$t(`${_ctx.translationKey}.UploadPhotoIdentityDocument`)
                }, null, 8, _hoisted_24))
              : _createCommentVNode("", true),
            (_ctx.isPhotoUpload && !_ctx.isBadUpload)
              ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.IDisClear`)), 1))
              : _createCommentVNode("", true),
            (_ctx.isPhotoUpload && _ctx.isBadUpload)
              ? (_openBlock(), _createElementBlock("h1", {
                  key: 3,
                  class: "container__standard-header",
                  innerHTML: _ctx.$t(`${_ctx.translationKey}.uploadAgain`)
                }, null, 8, _hoisted_26))
              : _createCommentVNode("", true),
            (_ctx.isPhotoUpload && _ctx.isBadUpload)
              ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.uploadAgainInstructions`)), 1))
              : _createCommentVNode("", true),
            (_ctx.isPhotoUpload)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 5,
                  type: "button",
                  class: "photo-examples",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleShowPopup && _ctx.handleShowPopup(...args)))
                }, [
                  _hoisted_28,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.translationKey}.GoodAndBadPhotoExamples`)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showHowToTakePicture)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createVNode(_component_HowToTakePicture, { onChildEvent: _ctx.handleHowToTakePicture }, null, 8, ["onChildEvent"])
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass({ 'manual-upload': _ctx.isPhotoUpload })
            }, [
              _withDirectives(_createElementVNode("div", _hoisted_30, [
                _createElementVNode("h2", {
                  innerHTML: 
                            _ctx.$t(
                                `${_ctx.translationKey}.EstabilishingSecureConnection`
                            )
                        
                }, null, 8, _hoisted_31),
                _createElementVNode("div", {
                  class: _normalizeClass(["client-zone-loader", { oanda: _ctx.UtilityHelper.isOandaPath() }])
                }, null, 2)
              ], 512), [
                [_vShow, _ctx.isSecuringConnection]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(["gbg-camera-container", {
                        'show-help': _ctx.showHelp,
                        'show-camera': _ctx.isShowCamera,
                        'photo-upload': _ctx.isPhotoUpload,
                        'is-back': _ctx.isBack,
                    }])
              }, [
                (_ctx.showPopup)
                  ? (_openBlock(), _createBlock(_component_HowToTakePicture, {
                      key: 0,
                      "is-popup": true
                    }))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_SecurityPopup, null, null, 512), [
                  [_vShow, _ctx.securityPopup]
                ]),
                (_ctx.helpAvailable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("h3", null, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.HowCanWeHelpYou`)), 1)
                        ]),
                        _createElementVNode("ul", _hoisted_36, [
                          _createElementVNode("li", {
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showCameraSelection && _ctx.showCameraSelection(...args)))
                          }, [
                            _hoisted_37,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(
                                            `${_ctx.translationKey}.WrongCameraClickHere`
                                        )), 1)
                          ]),
                          _createElementVNode("li", {
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleShowPopup && _ctx.handleShowPopup(...args)))
                          }, [
                            _hoisted_38,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(
                                            `${_ctx.translationKey}.HowToTakeGoodPicture`
                                        )), 1)
                          ]),
                          _createElementVNode("li", {
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleManual && _ctx.handleManual(...args)))
                          }, [
                            _hoisted_39,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(
                                            `${_ctx.translationKey}.TakePictureManually`
                                        )), 1)
                          ]),
                          _createElementVNode("li", {
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleSecurity && _ctx.handleSecurity(...args)))
                          }, [
                            _hoisted_40,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(
                                            `${_ctx.translationKey}.SecurityOfYourData`
                                        )), 1)
                          ]),
                          _createElementVNode("li", {
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleUpload && _ctx.handleUpload(...args)))
                          }, [
                            _hoisted_41,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(
                                            `${_ctx.translationKey}.SkipToUploadFiles`
                                        )), 1)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isPhotoUpload && _ctx.isBack)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.FrontSideThankYou`)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  id: "gbgContainer",
                  ref: "gbgContainer",
                  class: _normalizeClass(["gbgContainer", {
                            'oanda-loader': _ctx.UtilityHelper.isOandaPath(),
                            'show-loader': _ctx.showLoader,
                            'photo-upload': _ctx.isPhotoUpload,
                            'custom-notification': _ctx.showCustomNotification,
                        }])
                }, null, 2)
              ], 2), [
                [_vShow, !_ctx.isSecuringConnection]
              ])
            ], 2), [
              [_vShow, !_ctx.showHowToTakePicture]
            ]),
            (_ctx.isPhotoUpload)
              ? (_openBlock(), _createBlock(_component_NavigationButton, {
                  key: 7,
                  "path-name": "personalDataConfirm",
                  "default-look": false,
                  text: _ctx.$t(`${_ctx.translationKey}.skipStep`)
                }, null, 8, ["text"]))
              : _createCommentVNode("", true)
          ]))
  ]))
}